import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyFigIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./FigIcon-0b0c921d.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyFigIcon as P };
